import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
	storage: window.localStorage
})

export default new Vuex.Store({
	state: {
		locale: null,
		mobileInstallAppClosed: null
	},
	mutations: {
		SET_LOCALE (state, newLocale) {
			state.locale = newLocale;
		},
		CLOSE_APP (state, wasClosed) {
			state.mobileInstallAppClosed = wasClosed;
		}
	},
	getters: {
		LOCALE: state => {
			return state.locale;
		},
		APP_CLOSED: state => {
			return state.mobileInstallAppClosed;
		}
	},
	actions: {

	},
	plugins: [vuexLocal.plugin]
})
